module.exports = __webpack_public_path__ + "img/混动.4867f31d.png";